module.exports = __webpack_public_path__ + "static/media/freespace.ce8fa64d.svg";